<template>
  <v-layout row wrap>
    <v-flex xs6>
      <v-menu ref="startMenu" :close-on-content-click="false" v-model="startMenu" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
        <v-text-field slot="activator" label="Start Date" v-model="prettyStartDate" :error="
						(!startDateParsed.isValid &&
							startDateText.length > 0) ||
							(!checkErrorStartDatePrecedesEndDate &&
								startDateParsed.isValid &&
								endDateParsed.isValid)
					" prepend-icon="event"></v-text-field>
        <v-date-picker ref="startDate" :value="startDate" @input="onStartDateSelected" no-title scrollable actions :min="minDateBound" :max="maxDateBound" :events="setDateMark">
          <div style="display:block;width:100%;">
            <div v-show="
								this.$refs.startDate &&
									this.$refs.startDate._data.activePicker ==
										'DATE'
							">
              <div style="display:block;">
                <div style="display:flex;align-items:center;padding-left:8px;">
                  <div class="showData"></div>&nbsp;- Available data
                </div>
                <div style="display:flex;align-items:center;padding-left:8px;">
                  <div class="hideData"></div>&nbsp;- Hidden data
                </div>
              </div>
            </div>
            <div style="display:flex;">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="startMenu = false">{{ $t("Button.Cancel") }}</v-btn>
              <v-btn flat color="primary" @click="$refs.startMenu.save(startDateText)">{{ $t("Button.OK") }}</v-btn>
            </div>
          </div>
        </v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs6>
      <v-menu ref="endMenu" :close-on-content-click="false" v-model="endMenu" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
        <v-text-field slot="activator" label="End Date" v-model="prettyEndDate" :error="
						(!endDateParsed.isValid && endDateText.length > 0) ||
							(!checkErrorStartDatePrecedesEndDate &&
								endDateParsed.isValid &&
								startDateParsed.isValid)
					" prepend-icon="event"></v-text-field>
        <v-date-picker ref="endDate" :value="endDate" @input="onEndDateSelected" no-title scrollable actions :min="minDateBound" :max="maxDateBound" :events="setDateMark">
          <div style="display:block;width:100%;">
            <div style="display:block;width:100%;" v-show="
								this.$refs.endDate &&
									this.$refs.endDate._data.activePicker ==
										'DATE'
							">
              <div style="display:block;">
                <div style="display:flex;align-items:center;padding-left:8px;">
                  <div class="showData"></div>&nbsp;- Available data
                </div>
                <div style="display:flex;align-items:center;padding-left:8px;">
                  <div class="hideData"></div>&nbsp;- Hidden data
                </div>
              </div>
            </div>
            <div style="display:flex;">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="endMenu = false">{{ $t("Button.Cancel") }}</v-btn>
              <v-btn flat color="primary" @click="$refs.endMenu.save(endDateText)">{{ $t("Button.OK") }}</v-btn>
            </div>
          </div>
        </v-date-picker>
      </v-menu>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex xs12>
      <div class="text-xs-center">
        <span v-if="minDateBound != '' && maxDateBound != ''">
          <small>
            Available data:
            {{ formatDateTime(minDateBound, { format: "LL", excludeUtcText: true }) }} to {{ formatDateTime(maxDateBound, { format: "LL", excludeUtcText: true }) }}
          </small>
        </span>
        <preset-buttons :direction="direction" :min-date-bound="minDateBound" :max-date-bound="maxDateBound" @input="onDatePresetSelected" :date-range-shortcuts="dateRangeShortcuts"></preset-buttons>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  import PresetButtons from './PresetButtons'
  import MomentUtil from './mixins/MomentUtil'
  import { format, parse, max, subWeeks, subMonths, subYears } from 'date-fns'
  import moment from 'moment'
  export default {
    components: { 'preset-buttons': PresetButtons },
    mixins: [MomentUtil],
    props: {
      initializeBounded: {
        type: Boolean,
        default: false,
      },
      direction: {
        type: String,
        default: 'bottom',
      },
      minDateBound: {
        type: String, // YYYY-MM-DD
        default: '',
      },
      maxDateBound: {
        type: String, // YYYY-MM-DD
        default: '',
      },
      triggerReset: {
        // toggle between 0 and 1 to trigger date pickers to reset to auto date range.
        type: Number,
        default: 0,
      },
      resetDateRangeOption: {
        // string option found in preset-buttons e.g. 'Most recent two weeks'
        type: String,
        default: '',
      },
      utcOffsetMinutes: {
        type: Number,
        default: 0,
      },
      calendarMark: {
        type: Map,
        default: () => {
          new Map()
        },
      },
      startDateValue: {
        type: Date,
        default: () => {},
      },
      endDateValue: {
        type: Date,
        default: () => {},
      },
    },
    data() {
      return {
        startMenu: false,
        endMenu: false,
        startDateText: '',
        endDateText: '',
        startDate: '',
        endDate: '',
        startDateParsed: {},
        endDateParsed: {},
        errorTextInvalidDate: 'Enter a valid date',
        errorTextStartDateFollowsEndDate: 'Start Date must be earlier than End Date',
        prettyFormat: 'MMM D, YYYY',
      }
    },
    computed: {
      prettyStartDate() {
        if (this.startDateValue) { this.startDateText = this.formatDateForSentinel(this.startDateValue) }
        if (!this.startDateText) return ''
        return moment(this.startDateText).format(this.prettyFormat)
      },
      prettyEndDate() {
        if (this.endDateValue) { this.endDateText = this.formatDateForSentinel(this.endDateValue) }
        if (!this.endDateText) return ''
        return moment(this.endDateText).format(this.prettyFormat)
      },
      checkErrorStartDatePrecedesEndDate() {
        // Returns true if both startDate and endDate are valid and startDate comes before endDate or is the same.
        return (
          this.startDateParsed.isValid &&
          this.endDateParsed.isValid &&
          this.isDateBeforeOrSame(
            this.startDateParsed.parsedMoment,
            this.endDateParsed.parsedMoment
          )
        )
      },
      dateRangeShortcuts() {
        return {
          'All available data': {
            startDate: this.minDateBound || this.defaultMinDateBound,
            endDate: this.maxDateBound || this.defaultMaxDateBound,
          },
          'Most recent two weeks': {
            startDate: format(
              max(
                parse(
                  this.minDateBound || this.defaultMinDateBound
                ),
                subWeeks(
                  this.maxDateBound || this.defaultMaxDateBound,
                  2
                )
              ),
              'YYYY-MM-DD'
            ),
            endDate: this.maxDateBound,
          },
          'Most recent month': {
            startDate: format(
              max(
                parse(
                  this.minDateBound || this.defaultMinDateBound
                ),
                subMonths(
                  this.maxDateBound || this.defaultMaxDateBound,
                  1
                )
              ),
              'YYYY-MM-DD'
            ),
            endDate: this.maxDateBound,
          },
          'Most recent 3 months': {
            startDate: format(
              max(
                parse(
                  this.minDateBound || this.defaultMinDateBound
                ),
                subMonths(
                  this.maxDateBound || this.defaultMaxDateBound,
                  3
                )
              ),
              'YYYY-MM-DD'
            ),
            endDate: this.maxDateBound,
          },
          'Most recent year': {
            startDate: format(
              max(
                parse(
                  this.minDateBound || this.defaultMinDateBound
                ),
                subYears(
                  this.maxDateBound || this.defaultMaxDateBound,
                  1
                )
              ),
              'YYYY-MM-DD'
            ),
            endDate: this.maxDateBound,
          },
        }
      },
      defaultMaxDateBound() {
        return new Date().toISOString().slice(0, 10)
      },
      defaultMinDateBound() {
        return new Date(0).toISOString().slice(0, 10)
      },
    },
    watch: {
      triggerReset() {
        if (
          this.resetDateRangeOption &&
          Object.keys(this.dateRangeShortcuts).includes(
            this.resetDateRangeOption
          )
        ) {
          this.onDatePresetSelected(this.resetDateRangeOption)
        }
      },
      startMenu(val) {
        val &&
          this.$nextTick(
            () => (this.$refs.startDate.activePicker = 'YEAR')
          )
      },
      endMenu(val) {
        val &&
          this.$nextTick(
            () => (this.$refs.endDate.activePicker = 'YEAR')
          )
      },
      minDateBound(current, previous) {
        if (current && !previous && this.initializeBounded) {
          this.initialize()
        }
      },
    },
    methods: {
      initialize() {
        this.onStartDateSelected(this.minDateBound)
        this.onEndDateSelected(this.maxDateBound)
      },
      onStartDateTextInput(newText) {
        var parsed = this.parseDateTextToMoment(newText, {
          format: 'YYYY-MM-DD',
        })
        this.startDateParsed = parsed
        if (parsed.isValid) {
          this.startDate = this.formatDateFromMoment(parsed.parsedMoment)
        } else {
          this.endDate = null
        }
        this.emitInputEvent()
      },
      onEndDateTextInput(newText) {
        var parsed = this.parseDateTextToMoment(newText, {
          format: 'YYYY-MM-DD',
        })
        this.endDateParsed = parsed
        if (parsed.isValid) {
          this.endDate = this.formatDateFromMoment(parsed.parsedMoment)
        } else {
          this.endDate = null
        }
        this.emitInputEvent()
      },
      onStartDateSelected(newDateText) {
        var parsed = this.parseDateTextToMoment(newDateText, {
          format: 'YYYY-MM-DD',
        })
        this.startDateParsed = parsed
        if (parsed.isValid) {
          this.startDateText = this.formatDateFromMoment(
            parsed.parsedMoment,
            'YYYYMMDD'
          )
          this.startDate = newDateText
        }
        this.emitInputEvent()
      },
      onEndDateSelected(newDateText) {
        var parsed = this.parseDateTextToMoment(newDateText, {
          format: 'YYYY-MM-DD',
        })
        this.endDateParsed = parsed
        if (parsed.isValid) {
          this.endDateText = this.formatDateFromMoment(
            parsed.parsedMoment,
            'YYYYMMDD'
          )
          this.endDate = newDateText
        }
        this.emitInputEvent()
      },
      onDatePresetSelected(presetName) {
        var dateRangeObj = this.dateRangeShortcuts[presetName]
        var parsedStart = this.parseDateTextToMoment(
          dateRangeObj.startDate, {
            format: 'YYYY-MM-DD',
          }
        )
        var parsedEnd = this.parseDateTextToMoment(dateRangeObj.endDate, {
          format: 'YYYY-MM-DD',
        })
        this.startDateParsed = parsedStart
        this.endDateParsed = parsedEnd
        if (parsedStart.isValid && parsedEnd.isValid) {
          this.startDateText = this.formatDateFromMoment(
            parsedStart.parsedMoment,
            'YYYYMMDD'
          )
          this.endDateText = this.formatDateFromMoment(
            parsedEnd.parsedMoment,
            'YYYYMMDD'
          )
          this.startDate = this.formatDateFromMoment(
            parsedStart.parsedMoment
          )
          this.endDate = this.formatDateFromMoment(
            parsedEnd.parsedMoment
          )
        }
        this.emitInputEvent()
      },
      emitInputEvent() {
        // Start date will be truncated to start of day. End date will be pushed to end of day.
        // Handle the user-specified time-zone offset.
        var startParsed = JSON.parse(JSON.stringify(this.startDateParsed))
        var endParsed = JSON.parse(JSON.stringify(this.endDateParsed))
        startParsed.parsedMoment = moment(startParsed.parsedMoment)
          .utcOffset(this.utcOffsetMinutes, true)
          .startOf('day')
        startParsed.parsedDate = startParsed.parsedMoment.toDate()
        endParsed.parsedMoment = moment(endParsed.parsedMoment)
          .utcOffset(this.utcOffsetMinutes, true)
          .endOf('day')
        endParsed.parsedDate = endParsed.parsedMoment.toDate()

        this.$emit('input', { startDate: startParsed, endDate: endParsed })
      },
      setDateMark(date) {
        //component return date is string
        if (this.calendarMark && this.calendarMark.has(date)) {
          return this.calendarMark.get(date)
        } else {
          return false
        }
      },
    },
  }
</script>
<style lang="stylus" scoped>
  .showData {
    height: 8px;
    width: 8px;
    background-color: #fb8c00 !important;
    border-color: #fb8c00 !important;
    border-radius: 50%;
  }

  .hideData {
    height: 8px;
    width: 8px;
    background-color: red !important;
    border-color: red !important;
    border-radius: 50%;
  }
</style>